import Trending from '@/docs-partials/api/endpoints/trending.mdx';
import * as React from 'react';
export default {
  Trending,
  React
};